import { useAuth } from "../contexts/authContext";
import { Navigate, useLocation } from "react-router-dom";
import GlobalLoader from "./GlobalLoader";

function ProtectedRoute({ children, allowedRoles }) {
  const { isAuthenticated, loadingUser, user } = useAuth();
  const location = useLocation();
  const roleHomePath = user?.role === "blogEditor" ? "/blog-admin" : "/dashboard";

  // Show loading state while checking authentication
  if (loadingUser) {
    return <GlobalLoader fullPage={true} />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role if allowedRoles is provided
  if (allowedRoles && (!user || !allowedRoles.includes(user.role))) {
    return <Navigate to={roleHomePath} replace />;
  }

  if (!allowedRoles && user?.role === "blogEditor" && !location.pathname.startsWith("/blog-admin")) {
    return <Navigate to="/blog-admin" replace />;
  }

  // Render children if authenticated+
  return children;
}

export default ProtectedRoute;
